import React from 'react';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import { useLangFile } from 'js/context/LanguageContext';

const styles = (theme) => ({
  root: {
    pointerEvents: 'all',
  },
  title: {
    flexGrow: 1,
  },
});

const GpsFixAppBar = ({ classes, onClose }) => {
  const LangFile = useLangFile();

  return (
    <AppBar color={'inherit'} position="static" className={classes.root}>
      <Toolbar variant="dense">
        <IconButton edge="start" color="inherit" onClick={onClose}>
          <Close />
        </IconButton>

        <Typography variant="h6" className={classes.title}>
          {LangFile.GpsFixAppBar.title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

GpsFixAppBar.propTypes = {
  onClose: PropTypes.func,
};

export default withStyles(styles)(GpsFixAppBar);
